import { ESTAB_FALLBACK_IMAGES, getURIS } from 'constants/constants';
import React, { Component } from 'react';
import SeoEstablishmentCard, { SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS } from 'molecules/seo-establishment-card';
import Hr from 'service-client-js';
import PropTypes from 'prop-types';

Hr.setConfig({ SEARCH_SERVICE: getURIS().SEARCH });


export default class SeoEstablishmentCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { images: [] };
  }

  handleEvents(clickSection, clickSubSection) {
    const { establishment } = this.props;
    const { images } = this.state;
    switch (clickSubSection) {
      case SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS.SLIDE_CHANGE:
        if (!images.length) {
          Hr.establishment.get(establishment.id).images()
            .then(imgs => this.setState({ images: imgs }))
            .catch();
        }
        break;
      case SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS.IMAGES:
        window.open(establishment.href, '_self');
        break;
      default:
        break;
    }
  }

  render() {
    const { establishment, t } = this.props;
    let { images } = this.state;
    if (!establishment) return null;
    images = images.length ? images : establishment.images;
    return (
      <SeoEstablishmentCard
        area={ establishment.area }
        city={ establishment.city }
        clickinHref={ establishment.href }
        comments={ establishment.numberOfComments }
        estabFallbackImages={ ESTAB_FALLBACK_IMAGES }
        establishment={ establishment }
        establishmentImages={ images }
        establishmentNumberImages={ establishment.numberOfImages }
        establishmentTitle={ establishment.title ? establishment.title.split('\n').join('').trim() : '' }
        establishmentType={ establishment.type }
        guests={ establishment.maxGuests }
        handleOnClick={ (this.handleEvents.bind(this)) }
        isFollow={ establishment.follow }
        rating={ establishment.partnerRating }
        t={ t }
        titlePreposition={ establishment.titlePreposition }
      />
    );
  }
}

SeoEstablishmentCardContainer.propTypes = {
  establishment: PropTypes.shape({
    href: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    images: PropTypes.array,
    statsOfComments: PropTypes.object,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
